// extracted by mini-css-extract-plugin
export default {"popover":"f1PCZ","sharemenu":"+uFRK","icon":"Rp0tq"};